export const blockIconsTravelStairsNew = (
	<span className='material-symbols-outlined'>stairs</span>
);
